export default __webpack_public_path__ + "static/media/ME.39bee176.jpeg";